export default __webpack_public_path__ + "static/media/NC_512x512_short.ba57af09.png";